import { FC } from 'react'

import { UserInfoBox } from './user-info-box'
import { SRSelectOptions } from '../../sr-form-elements'
import { EditableType } from './enums'

export type UserInfoItem = {
  name?: string
  label: string
  value: string
  isEditing?: boolean
  hasToGrow?: boolean
  editableType?: EditableType
  selectOptions?: SRSelectOptions
  selectValue?: string | number
  isReadOnly?: boolean
  formattedValue?: string
  isTextarea?: boolean
}

type UserInfoProps = {
  data: UserInfoItem[]
}

export const UserInfo: FC<UserInfoProps> = ({ data }) => {
  if (!data) return null
  return (
    <div className='md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-y-6 gap-x-8 relative mb-4' data-testid="user-info">
      {data.map(
        (
          {
            name,
            label,
            value,
            isEditing = false,
            editableType = EditableType.input,
            hasToGrow = false,
            selectOptions = [],
            selectValue,
            formattedValue,
            isTextarea,
          },
          ix: number,
        ) => {
          return (
            <UserInfoBox
              key={`user-info-read-box-${ix}`}
              name={name}
              label={label}
              value={value}
              isEditing={isEditing}
              hasToGrow={hasToGrow}
              editableType={editableType}
              selectOptions={selectOptions}
              selectValue={selectValue}
              formattedValue={formattedValue}
              isTextarea={isTextarea}
            />
          )
        },
      )}
    </div>
  )
}
